import type { ReactNode } from 'react';

import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

type StatusScreenContentProps = {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
};

export const StatusScreenContent = ({
  icon,
  title,
  description,
  action,
}: StatusScreenContentProps) => {
  return (
    <div className="my-auto flex flex-col items-center">
      <div className="size-55">{icon}</div>

      <div className="w-full py-8 text-center">
        <Typography.Title size="s">{title}</Typography.Title>

        <Typography.Text size="m" color="secondary" className="mt-3">
          {description}
        </Typography.Text>

        {action && (
          <Button
            type="button"
            size="l"
            variant="primary"
            onClick={action.onClick}
            className="mt-6"
          >
            {action.label}
          </Button>
        )}
      </div>
    </div>
  );
};
